var _defs, _title, _path, _g, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _path6, _circle6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoaiguaDeviceManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    style: {},
    className: "selected"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_314_9376",
    x: 0.3833009898662567,
    y: 3.9145500659942627,
    width: 27.16309928894043,
    height: 27.802400588989258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_314_9376"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_314_9376",
    result: "shape"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3325 13.0623C18.3468 13.3344 18.3468 13.6065 18.3325 13.8787L18.9985 14.2654C19.2277 14.4086 19.3136 14.602 19.2563 14.8455C18.9985 15.7621 18.533 16.557 17.8599 17.2302C17.6737 17.4164 17.466 17.4451 17.2368 17.3162L16.5708 16.9294C16.3416 17.087 16.1053 17.2231 15.8618 17.3376V18.1111C15.8618 18.3832 15.7329 18.5551 15.4751 18.6267C14.5584 18.8702 13.6418 18.8702 12.7251 18.6267C12.6248 18.5981 12.5317 18.5336 12.4458 18.4333C12.3742 18.3331 12.3384 18.2257 12.3384 18.1111V17.3376C12.0949 17.2231 11.8586 17.087 11.6294 16.9294L10.9634 17.3162C10.7342 17.4451 10.5265 17.4164 10.3403 17.2302C9.66715 16.557 9.20166 15.7621 8.94385 14.8455C8.88656 14.602 8.97249 14.4086 9.20166 14.2654L9.86768 13.8787C9.86768 13.7498 9.86768 13.6137 9.86768 13.4705C9.86768 13.3272 9.86768 13.1912 9.86768 13.0623L9.20166 12.6755C8.97249 12.5323 8.88656 12.3389 8.94385 12.0955C9.20166 11.1788 9.66715 10.3839 10.3403 9.71069C10.5265 9.5245 10.7342 9.49585 10.9634 9.62476L11.6294 10.0115C11.8586 9.85392 12.0949 9.71785 12.3384 9.60327V8.82983C12.3384 8.5577 12.4673 8.38582 12.7251 8.31421C13.6418 8.07072 14.5584 8.07072 15.4751 8.31421C15.5754 8.34285 15.6613 8.40731 15.7329 8.50757C15.8188 8.60783 15.8618 8.71525 15.8618 8.82983V9.60327C16.1053 9.71785 16.3416 9.85392 16.5708 10.0115L17.2368 9.62476C17.466 9.49585 17.6737 9.5245 17.8599 9.71069C18.533 10.3839 18.9985 11.1788 19.2563 12.0955C19.3136 12.3389 19.2277 12.5323 18.9985 12.6755L18.3325 13.0623ZM17.1938 14.4158C17.2798 13.9718 17.3228 13.6567 17.3228 13.4705C17.3228 13.2843 17.2798 12.9692 17.1938 12.5251L18.1392 11.988C17.9673 11.5297 17.7238 11.1072 17.4087 10.7205L16.4634 11.2576C16.2199 11.057 16.0337 10.9138 15.9048 10.8279C15.7759 10.7276 15.6398 10.6488 15.4966 10.5916C15.3534 10.5199 15.1313 10.4268 14.8306 10.3123V9.23804C14.5871 9.19507 14.3436 9.17358 14.1001 9.17358C13.8566 9.17358 13.6131 9.19507 13.3696 9.23804V10.3123C12.9543 10.4698 12.6606 10.5987 12.4888 10.699C12.3312 10.7849 12.0806 10.9711 11.7368 11.2576L10.7915 10.7205C10.4764 11.1072 10.2329 11.5297 10.061 11.988L11.0063 12.5251C10.9204 12.9692 10.8774 13.2843 10.8774 13.4705C10.8774 13.6567 10.9204 13.9718 11.0063 14.4158L10.061 14.9529C10.2329 15.4112 10.4764 15.8337 10.7915 16.2205L11.7368 15.6833C12.0806 15.9698 12.3312 16.1632 12.4888 16.2634C12.6606 16.3494 12.9543 16.4711 13.3696 16.6287V17.7029C13.6131 17.7458 13.8566 17.7673 14.1001 17.7673C14.3436 17.7673 14.5871 17.7458 14.8306 17.7029V16.6287C15.1313 16.5141 15.3534 16.4281 15.4966 16.3708C15.6398 16.2992 15.7759 16.2205 15.9048 16.1345C16.0337 16.0343 16.2199 15.8839 16.4634 15.6833L17.4087 16.2205C17.7238 15.8337 17.9673 15.4112 18.1392 14.9529L17.1938 14.4158ZM12.6392 12.0095C13.0402 11.6085 13.5272 11.408 14.1001 11.408C14.673 11.408 15.16 11.6085 15.561 12.0095C15.9621 12.4106 16.1626 12.8975 16.1626 13.4705C16.1626 14.0434 15.9621 14.5304 15.561 14.9314C15.16 15.3324 14.673 15.533 14.1001 15.533C13.5272 15.533 13.0402 15.3324 12.6392 14.9314C12.2381 14.5304 12.0376 14.0434 12.0376 13.4705C12.0376 12.8975 12.2381 12.4106 12.6392 12.0095ZM13.3696 14.2009C13.5701 14.4014 13.8136 14.5017 14.1001 14.5017C14.3866 14.5017 14.63 14.4014 14.8306 14.2009C15.0311 14.0004 15.1313 13.7569 15.1313 13.4705C15.1313 13.184 15.0311 12.9405 14.8306 12.74C14.63 12.5395 14.3866 12.4392 14.1001 12.4392C13.8136 12.4392 13.5701 12.5395 13.3696 12.74C13.1691 12.9405 13.0688 13.184 13.0688 13.4705C13.0688 13.7569 13.1691 14.0004 13.3696 14.2009Z",
    fill: "white",
    id: "svg_1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_314_9376)",
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1746 4.66109C15.4646 4.47134 15.7074 4.21532 15.8815 3.91453L21.4596 7.13508C21.3132 7.46105 21.2466 7.81994 21.2685 8.17942L15.1746 4.66109ZM22.5464 10.0509C22.8582 10.1952 23.2011 10.266 23.5464 10.2555V16.7886C23.2062 16.7518 22.8637 16.7949 22.5464 16.9108V10.0509ZM21.1838 19.6131C21.2778 19.9331 21.4439 20.2323 21.6748 20.4843L16.0758 23.7169C15.9731 23.3909 15.797 23.0975 15.5668 22.856L21.1838 19.6131ZM5.38329 16.9106C5.06601 16.7947 4.72352 16.7515 4.38329 16.7884V10.4018C4.72352 10.4386 5.06601 10.3954 5.38329 10.2795V16.9106ZM12.7551 4.66109L6.83269 8.08041C6.81341 7.73432 6.7131 7.39603 6.53963 7.09491L12.0482 3.91453C12.2223 4.21532 12.4651 4.47134 12.7551 4.66109ZM11.8539 23.7169L6.25461 20.4841C6.4856 20.2322 6.65167 19.933 6.74573 19.613L12.3629 22.856C12.1327 23.0975 11.9566 23.3909 11.8539 23.7169Z",
    fill: "white",
    id: "svg_3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.964699745178223,
    cy: 2.8082199096679688,
    r: 1.7127699851989746,
    stroke: "white",
    id: "svg_4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9646 6.12738V5.57419V5.021",
    stroke: "white",
    strokeLinecap: "round",
    id: "svg_5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.964699745178223,
    cy: 24.382699966430664,
    r: 1.7127699851989746,
    transform: "rotate(-180 13.9647 24.3827)",
    stroke: "white",
    id: "svg_6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9648 21.0635L13.9648 21.6167L13.9648 22.1699",
    stroke: "white",
    strokeLinecap: "round",
    id: "svg_7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.477399826049805,
    cy: 8.043689727783203,
    r: 1.7127699851989746,
    transform: "rotate(60 23.4774 8.04369)",
    stroke: "white",
    id: "svg_8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6029 9.70322L21.082 9.42662L21.561 9.15002",
    stroke: "white",
    strokeLinecap: "round",
    id: "svg_9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6226701736450195,
    cy: 18.98889923095703,
    r: 1.7127699851989746,
    transform: "rotate(-120 4.62267 18.9889)",
    stroke: "white",
    id: "svg_10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49722 17.3294L7.01814 17.606L6.53906 17.8826",
    stroke: "white",
    strokeLinecap: "round",
    id: "svg_11"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.306699752807617,
    cy: 18.989299774169922,
    r: 1.7127699851989746,
    transform: "rotate(120 23.3067 18.9893)",
    stroke: "white",
    id: "svg_12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4322 17.3296L20.9113 17.6062L21.3904 17.8828",
    stroke: "white",
    strokeLinecap: "round",
    id: "svg_13"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.623040199279785,
    cy: 8.201669692993164,
    r: 1.7127699851989746,
    transform: "rotate(-60 4.62304 8.20167)",
    stroke: "white",
    id: "svg_14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49746 9.8613L7.01838 9.5847L6.53931 9.30811",
    stroke: "white",
    strokeLinecap: "round",
    id: "svg_15"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoaiguaDeviceManagement);
export default __webpack_public_path__ + "static/media/goaigua-device-management.c274a25e.svg";
export { ForwardRef as ReactComponent };